
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"157","height":"175","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"78.125","cy":"78.125","r":"78.125","fill":"#005149"}}),_c('path',{attrs:{"d":"M6.51 62.5L19.53 75c32.357-31.062 84.831-31.062 117.188 0l13.021-12.5c-39.518-37.937-103.646-37.937-143.23 0zm52.083 50l19.531 18.75 19.532-18.75c-10.743-10.375-28.256-10.375-39.063 0zm-26.042-25L45.572 100c17.969-17.25 47.136-17.25 65.104 0l13.021-12.5c-25.13-24.125-65.95-24.125-91.146 0z","fill":"#fff"}}),_c('circle',{attrs:{"cx":"118.75","cy":"143.75","r":"29.75","fill":"#005149","stroke":"#fff","stroke-width":"3"}}),_c('path',{attrs:{"d":"M111.475 153.95l-10.425-10.425-3.55 3.525 13.975 13.975 30-30-3.525-3.525-26.475 26.45z","fill":"#fff"}})])
          )
        }
      }
    